import { buttonStyles, IStyledButtonProps } from "@components/button";
import { transparentize } from "polished";
import styled from "styled-components";

import { T_TITLE_2 } from "../../../global.style";

export const LoadingErrorWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 32px;
    background-color: ${(props) => transparentize(0.25, props.theme.C_ACT_hover_without_opacity ?? "#f2e1eb")};
`;

export const Title = styled.span`
    color: ${(props) => props.theme.C_ACT_der};
    ${T_TITLE_2}
    white-space: pre-wrap;
    text-align: center;
`;


// don't use Button as it may be used sooner than any context is available
export const LoadingErrorButton = styled.div<IStyledButtonProps>`
    ${buttonStyles}
`;
